import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppConfig } from '@config/app.config';
import { CONSTANT_CONFIG } from '@config/constants.config';
import { ConstantsService } from '@core/services/constants.service';
import { GeneralsService } from '@core/services/generals.service';
import { Constants } from '@shared/class/constants.class';
import { Constant } from '@shared/interfaces/constant';

@Component({
  selector: 'app-constants-edit',
  templateUrl: './constants-edit.component.html'
})
export class ConstantsEditComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public constant: Constant;
  public constantForm: FormGroup;
  public validators: Array<any> = [];

  constructor(
    public appConfig: AppConfig,
    private generalsService: GeneralsService,
    private constantsService: ConstantsService,
    public dialogRef: MatDialogRef<ConstantsEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    this.constant = this.data;
    this.constants.title =
      this.appConfig.LANG.title.edit +
      ' ' +
      this.appConfig.LANG.constants.title;
    this.validators = [];
    CONSTANT_CONFIG.forEach(element => {
      if (element.name === this.constant.name) {
        this.validators = element.value;
      }
    });
    this.validators.push(Validators.required);

    this.constantForm = new FormGroup({
      id: new FormControl(this.constant.id, Validators.required),
      name: new FormControl(
        { value: this.constant.name, disabled: true },
        Validators.required
      ),
      description: new FormControl(this.constant.description, [
        Validators.required
      ]),
      value: new FormControl(this.constant.value, this.validators)
    });
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.constantForm;
    if (form.dirty && form.valid) {
      this.generalsService.save(
        this.appConfig.ACTIONS.edit.id,
        form,
        this.dialogRef,
        this.constantsService
      );
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close(300);
  }
}
